import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for N351 (客訴單追蹤查詢)
// ============================================================

export interface ComplaintItem {
  fn110_01: string;  // 客訴單號
  fn110_11: string;  // 日期 (YYYY-MM-DD)
  fn110_22: string;  // 部門代碼
  fn110_221: string; // 客戶代碼
  fn110_23: number;  // 類型
  fn110_80: string;  // 核准節點80
  fn110_801: string; // 核准節點801
  fn110_802: string; // 核准節點802
  fn110_81: string;  // 核准節點81
  fn110_811: string; // 核准節點811
  fn110_812: string; // 核准節點812
  fn110_813: string; // 核准節點813
  fn110_82: string;  // 核准節點82
  fn110_84: string;  // 核准節點84
  fn110_93: string;  // 說明
  fn110_131: string; // 責任人1
  fn110_132: string; // 責任人2
}

export interface QueryResponse {
  items: ComplaintItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const n351Api = {
  /** Query complaint records with optional filters */
  async query(params: {
    startNo?: string;
    endNo?: string;
    startDate?: string;
    endDate?: string;
    node?: string;
  }): Promise<QueryResponse> {
    const p: Record<string, string> = {};
    if (params.startNo?.trim())   p['startNo']   = params.startNo.trim();
    if (params.endNo?.trim())     p['endNo']     = params.endNo.trim();
    if (params.startDate?.trim()) p['startDate'] = params.startDate.trim();
    if (params.endDate?.trim())   p['endDate']   = params.endDate.trim();
    if (params.node?.trim())      p['node']      = params.node.trim();
    const res = await apiClient.get('/api/n351/query', { params: p });
    return res.data;
  },
};
